<script setup>
import { useStoreGetters, useStore } from 'dashboard/composables/store';
import { computed, onMounted } from 'vue';
import { useBranding } from 'shared/composables/useBranding';
import IntegrationItem from './IntegrationItem.vue';
// NOTICE: KAPTION-INTEGRATION
import KaptionRumoMcpCard from './KaptionRumoMcpCard.vue';
import SettingsLayout from '../SettingsLayout.vue';
import BaseSettingsHeader from '../components/BaseSettingsHeader.vue';
// NOTICE: KAPTION-INTEGRATION - feature-permissions.DYNAMIC.2
import { useFeaturePermissions } from 'dashboard/composables/useFeaturePermissions';

const store = useStore();
const getters = useStoreGetters();
const { replaceInstallationName } = useBranding();
const { canUseFeature } = useFeaturePermissions();

const uiFlags = getters['integrations/getUIFlags'];

// NOTICE: KAPTION-INTEGRATION - hide integrations the user may not use (BE apps#index filters too)
const integrationList = computed(() =>
  getters['integrations/getAppIntegrations'].value.filter(item =>
    canUseFeature(`integration:${item.id}`)
  )
);

onMounted(() => {
  store.dispatch('integrations/get');
});
</script>

<template>
  <SettingsLayout
    :is-loading="uiFlags.isFetching"
    :loading-message="$t('INTEGRATION_SETTINGS.LOADING')"
  >
    <template #header>
      <BaseSettingsHeader
        :title="$t('INTEGRATION_SETTINGS.HEADER')"
        :description="
          replaceInstallationName($t('INTEGRATION_SETTINGS.DESCRIPTION'))
        "
        :link-text="$t('INTEGRATION_SETTINGS.LEARN_MORE')"
        feature-name="integrations"
      />
    </template>
    <template #body>
      <div class="flex-grow flex-shrink overflow-auto">
        <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
          <!-- NOTICE: KAPTION-INTEGRATION - Rumo MCP connections -->
          <KaptionRumoMcpCard />
          <IntegrationItem
            v-for="item in integrationList"
            :id="item.id"
            :key="item.id"
            :logo="item.logo"
            :name="item.name"
            :description="item.description"
            :enabled="item.enabled"
          />
        </div>
      </div>
    </template>
  </SettingsLayout>
</template>
